(function (document) {
  let x = document.querySelectorAll('.btn_addTo__Quote');
  let quote_url = '/pages/quote';
  let quotes = JSON.parse(localStorage.getItem('quotes')) || [];

  x?.forEach((bt) => {
    let filteredLenght = quotes.filter((q) => q.id == bt.dataset.productId);
    console.log(filteredLenght);
    bt.addEventListener('click', (e) => {
      e.preventDefault();
      let productId = bt.dataset.productId;
      let productHandle = bt.dataset.productHandle;
      let productSku = bt.dataset.productSku;
      let quotes = JSON.parse(localStorage.getItem('quotes')) || [];
      let quantity = document.querySelector('.quantity__input');

      let productData = {
        id: productId,
        handle: productHandle,
        sku: productSku,
        quantity: parseInt(quantity.value),
      };

      let isAlreadyExist = quotes.find((q) => q.id == productId);
      if (isAlreadyExist) {
        isAlreadyExist.quantity += parseInt(quantity.value);
      } else {
        quotes.push(productData);
      }

      localStorage.setItem('quotes', JSON.stringify(quotes));
      //   console.log(productId, productHandle, productSku);
      window.location.href = quote_url;
    });
  });
})(document);

class FetchQuotesProducts extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector('.left-section');
    this.drawerButton = document.querySelector('.right-section-product-list');
    this.drawerCloseButton = document.querySelector('.left-section--tile svg');
    this.submitButton = document.querySelector('.send-button');
    this.form = document.getElementById('ContactForm');
    this.productsElement = document.querySelector('.quote-products__list');
    this.productCountElement = document.querySelector('.product-count');

    let quotes = JSON.parse(localStorage.getItem('quotes')) || [];

    const productDetails = buildQuoteDetails(quotes);
    document.getElementById('contact_note').value = productDetails;
    let products = [];

    // Initialize event listeners
    this.init();

    let count = 0;
    quotes?.forEach((quote) => {
      count += 1;
      products.push(quote);
    });

    if (this.productCountElement) {
      this.productCountElement.innerHTML = count;
    }

    // Enable/disable submit button based on quote count
    if (this.submitButton) {
      this.submitButton.disabled = count === 0;
    }

    if (this.productsElement) {
      this.productsElement.innerHTML = '';
      this.productsElement.classList.remove('loading');
      this.renderProducts(products);
    }
    // this.updatedProductItems();
  }

  init() {
    // Drawer open/close events
    if (this.drawerButton) {
      this.drawerButton.addEventListener('click', this.openDrawer.bind(this));
    }

    if (this.drawerCloseButton) {
      this.drawerCloseButton.addEventListener('click', this.closeDrawer.bind(this));
    }
  }

  openDrawer() {
    if (!this.drawer) {
      this.drawer = document.querySelector('.left-section');
    }

    if (this.drawer) {
      this.drawer.classList.add('open');
    }
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.classList.remove('open');
    }
  }

  fetchProduct(handle, quantity, sku) {
    let $this = this;
    $this.productsElement.innerHTML = '';
    fetch(window.Shopify.routes.root + `products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        $this.productsElement.innerHTML += $this.renderHTML(product.title, quantity, sku, handle);

        $this.productsElement.classList.remove('loading');

        $this.productsElement.querySelectorAll('.product__conainer').forEach((list) => {
          let removeBTN = list.querySelector('.remove_btn');
          // console.log(removeBTN);
          removeBTN.addEventListener('click', (e) => {
            e.preventDefault();
            let x = removeBTN.dataset.sku;
            removeBTN.innerHTML = 'Loading...';
            $this.removeItemBySku(x);
            $this.fetchProduct();
            // $this.updatedProductItems();
          });
        });
      })
      .catch((err) => console.log(err));
  }

  addItem(title, quantity, sku, handle) {
    let quotes = JSON.parse(localStorage.getItem('quotes')) || [];
    let existingItem = quotes.find((item) => item.sku === sku);

    if (existingItem) {
      existingItem.quantity = parseInt(existingItem.quantity) + parseInt(quantity);
    } else {
      quotes.push({
        title,
        quantity,
        sku,
        handle,
        id: Date.now(),
      });
    }

    localStorage.setItem('quotes', JSON.stringify(quotes));

    if (this.productCountElement) {
      this.productCountElement.innerHTML = quotes.length;
    }

    // Enable submit button when products are added
    if (this.submitButton) {
      this.submitButton.disabled = quotes.length === 0;
    }

    const productDetails = buildQuoteDetails(quotes);
    document.getElementById('contact_note').value = productDetails;

    this.renderProducts(quotes);
  }

  removeItemBySku(sku) {
    let quotes = JSON.parse(localStorage.getItem('quotes')) || [];
    quotes = quotes.filter((item) => item.sku !== sku);
    localStorage.setItem('quotes', JSON.stringify(quotes));

    if (this.productCountElement) {
      this.productCountElement.innerHTML = quotes.length;
    }

    // Disable submit button when all products are removed
    if (this.submitButton) {
      this.submitButton.disabled = quotes.length === 0;
    }

    const productDetails = buildQuoteDetails(quotes);
    document.getElementById('contact_note').value = productDetails;
  }

  updatedProductItems() {
    const messageTextarea = document.querySelector('#message');
    messageTextarea.value = '';
    const quotes = JSON.parse(localStorage.getItem('quotes')) || [];
    const skuList = quotes.map((quote) => quote.sku).join(', ');

    if (messageTextarea) {
      messageTextarea.value = `Products : ${skuList}\n\n${messageTextarea.value}`;
    }
  }

  showFormMessage(message, type) {
    // Use the dedicated message container
    const messageContainer = document.getElementById('form-message-container');

    if (!messageContainer) {
      console.error('Message container not found');
      return;
    }

    // Create message element
    const messageElement = document.createElement('div');
    messageElement.className = `form-message form-message--${type}`;
    messageElement.textContent = message;

    // Clear any existing messages
    messageContainer.innerHTML = '';

    // Add the new message
    messageContainer.appendChild(messageElement);

    // Scroll to message
    messageContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Remove message after 5 seconds for success messages
    if (type === 'success') {
      setTimeout(() => {
        messageElement.style.opacity = '0';
        setTimeout(() => {
          messageElement.remove();
        }, 500);
      }, 5000);
    }
  }

  renderHTML(title, quantity, sku, handle) {
    return `<div class="product__conainer">
                <div class="product__details">
                  <h1><a href="${window.Shopify.routes.root}/products/${handle}">${title}</a></h1>
                  <div class="product__option">
                    <div><b>SKU</b>: ${sku}</div>
                    <div><b>Quantity</b>: ${quantity}</div>
                  </div>
                  <a href="#" class="remove_btn" data-sku="${sku}">Remove</a>
                </div>
            </div>`;
  }

  renderProducts(products) {
    if (!products || products.length === 0) {
      // Get customized empty quote settings if available
      const settings = window.emptyQuoteSettings || {
        title: 'Your Quote is Empty',
        message:
          "You haven't added any products to your quote yet. Browse our collections to find products you're interested in.",
        buttonText: 'Continue Shopping',
        buttonUrl: '/collections',
      };

      this.productsElement.innerHTML = `
        <div class="empty-quote">
          <h2>${settings.title}</h2>
          <p>${settings.message}</p>
          <a href="${settings.buttonUrl}" class="continue-shopping-btn">${settings.buttonText}</a>
        </div>
      `;
      return;
    }

    this.productsElement.innerHTML = '';

    // For each product in the quotes, create a skeleton loader first
    products.forEach((product) => {
      const tempId = `product-${product.id}`;

      // Add skeleton loader
      const skeletonHTML = `
        <div id="${tempId}" class="product__skeleton">
          <div class="product__skeleton-image skeleton"></div>
          <div class="product__skeleton-details">
            <div class="product__skeleton-title skeleton"></div>
            <div class="product__skeleton-option skeleton"></div>
            <div class="product__skeleton-option skeleton"></div>
          </div>
        </div>
      `;
      this.productsElement.innerHTML += skeletonHTML;

      // Fetch the product details
      fetch(window.Shopify.routes.root + `products/${product.handle}.js`)
        .then((res) => res.json())
        .then((productData) => {
          // Replace skeleton with actual product
          const productElement = document.getElementById(tempId);
          if (productElement) {
            // Create the real product element
            const realProductElement = document.createElement('div');
            realProductElement.id = tempId;
            realProductElement.className = 'product__conainer';
            realProductElement.innerHTML = `
              <div class="product__image-container">
                <img src="${
                  productData.featured_image ||
                  (productData.images && productData.images.length > 0 ? productData.images[0] : '')
                }" alt="${productData.title}" class="product__image">
              </div>
              <div class="product__details">
                <h1><a href="${window.Shopify.routes.root}/products/${product.handle}">${productData.title}</a></h1>
                <div class="product__option">
                  <div><b>SKU</b>: ${product.sku}</div>
                  <div><b>Quantity</b>: ${product.quantity}</div>
                </div>
                <a href="#" class="remove_btn" data-sku="${product.sku}">Remove</a>
              </div>
            `;

            // Replace the skeleton with the real product
            productElement.parentNode.replaceChild(realProductElement, productElement);

            // Add event listener to the remove button
            const removeBtn = realProductElement.querySelector('.remove_btn');
            if (removeBtn) {
              removeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.removeItemBySku(product.sku);
                this.renderProducts(JSON.parse(localStorage.getItem('quotes')) || []);

                // Update product count
                if (this.productCountElement) {
                  const quotes = JSON.parse(localStorage.getItem('quotes')) || [];
                  this.productCountElement.innerHTML = quotes.length;
                }
              });
            }
          }
        })
        .catch((err) => {
          console.error('Error fetching product:', err);
          // Replace skeleton with error state
          const productElement = document.getElementById(tempId);
          if (productElement) {
            // Create the error product element
            const errorProductElement = document.createElement('div');
            errorProductElement.id = tempId;
            errorProductElement.className = 'product__conainer';
            errorProductElement.innerHTML = `
              <div class="product__details">
                <h1>Product (SKU: ${product.sku})</h1>
                <div class="product__option">
                  <div><b>SKU</b>: ${product.sku}</div>
                  <div><b>Quantity</b>: ${product.quantity}</div>
                </div>
                <a href="#" class="remove_btn" data-sku="${product.sku}">Remove</a>
              </div>
            `;

            // Replace the skeleton with the error product
            productElement.parentNode.replaceChild(errorProductElement, productElement);

            // Add event listener to the remove button
            const removeBtn = errorProductElement.querySelector('.remove_btn');
            if (removeBtn) {
              removeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.removeItemBySku(product.sku);
                this.renderProducts(JSON.parse(localStorage.getItem('quotes')) || []);

                // Update product count
                if (this.productCountElement) {
                  const quotes = JSON.parse(localStorage.getItem('quotes')) || [];
                  this.productCountElement.innerHTML = quotes.length;
                }
              });
            }
          }
        });
    });
  }
}

customElements.define('quotes-products', FetchQuotesProducts);

function buildQuoteDetails(products) {
  let details = '\n\nQuote Product Details:';
  products.forEach((product) => {
    details += `\n\nProduct Id: ${product.id}\n`;
    details += `Product Handle: ${product.handle}\n`;
    details += `Product SKU: ${product.sku}\n`;
    details += `Product Quantity: ${product.quantity}\n`;
  });
  return details;
}

// Check for successful form submission and clear quotes
document.addEventListener('DOMContentLoaded', function () {
  // Check if the URL contains the success parameter
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get('contact_posted');
  const hashFragment = window.location.hash;

  // If form was successfully submitted, clear the quotes
  if (contactPosted === 'true' && hashFragment === '#ContactForm') {
    // Clear quotes from localStorage
    localStorage.setItem('quotes', JSON.stringify([]));

    // Update the product count display if it exists
    const productCountElement = document.querySelector('.product-count');
    if (productCountElement) {
      productCountElement.innerHTML = '0';
    }
  }
});
